import { changeLocale } from '@formkit/vue'

export default defineNuxtPlugin({
  name: 'zt:formkit',
  async setup() {
    const locale = useCurrentLangcodeEnum()
    changeLocale(locale.value.toLowerCase())
  },
})
